export default __webpack_public_path__ + "static/media/l8p1aWZqHvE.03904ea5.png";